import './index.css';

window[`_${window._pxAppId}`] = {
    challenge: {
        context: {
            logoImgSrc:
                'https://cdn-fs.clearscore.com/icons/@clearscore/rainbow.icons.clearscore/0.2.4/clearscore@3x.png',
            messageColor: '#263648',
            messageFontSize: '1rem',
            css: ['/px-human-challenge.css'],
            headerFont: 'CSClarity,Helvetica Neue,Helvetica,Arial,sans-serif',
        },
        view: {
            fillColor: '#66aec5',
            backgroundColor: '#0f81a3',
            borderRadius: 8,
            borderWidth: 0,
            textFont: 'CSClarity,Helvetica Neue,Helvetica,Arial,sans-serif',
            textColor: '#fff',
            targetColor: '#fff',
            texSize: 22,
        },
    },
};
